import type { MatchMode, ScanFilters } from '@/screens/scan/scanCache'
import type { ChecklistItem } from '@/screens/scan/types'

/** Match a string field against hash-set values using Partial (`cn`) or Exact (`in`). */
const matchesHashSet = (
  haystack: string | undefined,
  needles: string[],
  mode: MatchMode = 'cn'
): boolean => {
  if (!needles.length) return true
  if (!haystack) return false
  const lower = haystack.toLowerCase()
  if (mode === 'in') return needles.some((needle) => lower === needle.toLowerCase())
  return needles.some((needle) => lower.includes(needle.toLowerCase()))
}

/** True when an item passes every active client-side facet filter. */
export const matchesFilters = (item: ChecklistItem, filters: ScanFilters): boolean => {
  if (!matchesHashSet(item.name, filters.names, filters.matchModes.names)) return false
  if (!matchesHashSet(item.topic, filters.topics, filters.matchModes.topics)) return false
  if (filters.types.length && !(item.type && filters.types.includes(item.type))) return false
  if (filters.scopes.length && !(item.scope && filters.scopes.includes(item.scope))) return false
  if (filters.states.length && !item.states?.some((state) => filters.states.includes(state))) {
    return false
  }
  if (
    filters.businessTypes.length &&
    !(item.businessType && filters.businessTypes.includes(item.businessType))
  ) {
    return false
  }
  if (
    filters.typeOfInsuranceGroupIds.length &&
    !item.typeOfInsuranceGroupIds?.some((id) => filters.typeOfInsuranceGroupIds.includes(id))
  ) {
    return false
  }
  if (
    filters.typeOfInsurances.length &&
    !item.typeOfInsurances?.some((toi) => filters.typeOfInsurances.includes(toi))
  ) {
    return false
  }
  if (
    filters.subTypeOfInsurances.length &&
    !item.subTypeOfInsurances?.some((sub) => filters.subTypeOfInsurances.includes(sub))
  ) {
    return false
  }
  return true
}
